import {Component, input, inject, output} from '@angular/core';
import {StoreClosure} from '../../../classes/models/store/StoreClosure';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StoreClosureFormComponent} from './store-closure-form/store-closure-form.component';
import {DataService} from '../../../services/store/data.service';
import {StoreClosureDeleteComponent} from './store-closure-delete/store-closure-delete.component';

/**
 * This component handles displaying and editing store closures.
 */
@Component({
  selector: 'app-store-closure',
  templateUrl: './store-closure.component.html',
  styleUrls: ['./store-closure.component.less'],
})
export class StoreClosureComponent {
  private modalService = inject(NgbModal);
  dataService = inject(DataService);

  /** An identifier of a store. */
  readonly storeId = input<string>(undefined);
  /** A list of store closures to be displayed. */
  readonly storeClosures = input<StoreClosure[]>([]);
  /** An event to refresh store page data. */
  readonly getStoreDetailsEvent = output<void>();

  /**
   * Checks if data can be edited on the given date.
   * @param date the date, on which data might be edited.
   */
  canEditAtDate(date: string): boolean {
    return this.dataService.canEditAtDate(date);
  }

  /**
   * Opens a modal window to create a new store closure.
   */
  openCreate(): void {
    const modalRef = StoreClosureFormComponent.open(this.modalService, {
      storeId: this.storeId(),
      previousStoreClosure: undefined,
      weekExists: false
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a modal window to edit an existing store closure.
   * @param storeClosure the store closure, which will be updated.
   */
  openUpdate(storeClosure: StoreClosure): void {
    const modalRef = StoreClosureFormComponent.open(this.modalService, {
      storeId: this.storeId(),
      previousStoreClosure: storeClosure,
      weekExists: true
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a new modal window to delete an existing store closure.
   * @param date the date on which store closure should be deleted.
   */
  openDelete(date: string) {
    const modalRef = StoreClosureDeleteComponent.open(this.modalService, {
      storeId: this.storeId(),
      date: date
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }
}